<template>
    <div
        class="sliderImg__wrapper"
        :class="{ '--marginRight': name === 'carousel' && imgLength > 1 }"
        :style="`width: ${imgWidth}px; height: ${imgHeight}px;`"
        @mouseup="onMouseup($event)"
        @dragend="onDragend($event)"
        @touchend="onTouchend($event)">
        <img
            class="sliderImg__item"
            v-lazy="getImg(imgPath)"
            :width="imgWidth"
            :height="imgHeight"
            draggable="false">
    </div>
</template>

<script>
export default {
name: "SliderImg",
props: ['imgInfo', 'imgLength', 'name', 'imgPath', 'imgWidth', 'imgHeight'],
computed: {},
methods: {
    getImg(img) {
        return process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + img
    },
    /**
     * 親コンポーネント(Slider.vue)のスライド操作に必要なデータ手渡し
     * @param {Object} event 各イベント情報
     */
    onMouseup(event){
        this.$emit('onMouseup', event, this.imgInfo)
    },
    onDragend(event){
        this.$emit('onDragend', event, this.imgInfo)
    },
    onTouchend(event){
        this.$emit('onTouchend', event, this.imgInfo)
    }
}
}
</script>

<style lang="scss" scoped>
.sliderImg {
    &__wrapper {
        &.--marginRight { margin-right: 15px; }
    }
}
</style>
